import { isReadOnlyUser } from './access';
import { isSubscriptionReadOnly } from './subscriptionAccess';

/** ABM operativo deshabilitado (lector de equipo o mora en gracia). No usar para routing de /contador. */
export function isOperationalWriteDisabled(user) {
  if (!user) return true;
  return isReadOnlyUser(user) || isSubscriptionReadOnly(user);
}
